import { render, staticRenderFns } from "./nutritionDetail.html?vue&type=template&id=ffe2dbbe&scoped=true&"
import script from "./nutritionDetail.js?vue&type=script&lang=js&"
export * from "./nutritionDetail.js?vue&type=script&lang=js&"
import style0 from "./nutritionDetail.scss?vue&type=style&index=0&id=ffe2dbbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe2dbbe",
  null
  
)

export default component.exports